import React from 'react'
import DemoInputsSection from '../DemoInputsSection'
import DemoInputDateSimple from './DemoInputDateSimple'

const DemoInputDate = () => {

  return (
    <DemoInputsSection name="date">
      <DemoInputDateSimple/>
    </DemoInputsSection>
  )
}

export default DemoInputDate